import React, {useState, useEffect, useCallback, useRef } from 'react'
import { connect } from 'react-redux'
import { Line } from '@vds/lines';
import ProgressBar from './ProgressBar'; 
import SaveMiniCart from './SaveMiniCart';

const MainSubHeader = (props) => {

    const { lqState, appState, cartState,buildProductState,dispatch, onOpenModal, onhandleKeyDownKeyDown, isEnableSave, nsiPage, btnData, progressbar } = props;

    const isStickyProgressBar = buildProductState?.stickyProgressbar && ((lqState && lqState?.runtimeKey && lqState?.runtimeKey.enableStickyProgressBar === 'Y')) ;
    const pathName = window.location.pathname;
    const [isMobile, setIsMobile]  = useState((window.screen.width < 744));
    const [isTablet, setIsTablet] = useState(!!((window.screen.width > 743 && window.screen.width < 1025)));
    const isCartDataEmpty = !!(cartState?.cartData !== null && cartState?.cartData?.length !== 0);
    const [activeTabIndex, setactiveTabIndex] = useState(cartState.splitBillTab);        
    const splitBillTab = activeTabIndex;
    let topClassName= "w_Subheader";  
    let buildProductPage = true;
    let popularPlanPage =false;
    let checkoutpage  = false;
    const cartEmptyCheck = (buildProductState.internet.selectedProduct || buildProductState.tv.selectedProduct || cartState?.cartOrderDetail?.servicesOrdered?.indexOf("DATA") > -1  || cartState?.cartOrderDetail?.servicesOrdered?.indexOf("VIDEO") > -1) ? false : true;
    

    const wrapperRef = useRef(null);
    const [startX, setStartX] = useState(0);
    const [startY, setStartY] = useState(0);

    const w_subheadertop = isStickyProgressBar && progressbar ? 'w_Subheadermobiletop' :'w_Subheadertop';
    if(pathName=== '/inhome/ordersummary' || pathName=== '/inhome/checkout'){
        topClassName = `w_Subheader ${w_subheadertop}` ;
        buildProductPage = false;
        if(pathName === '/inhome/checkout'){
            checkoutpage = true;
        }
    } else if( pathName === '/inhome/popularPlans' || pathName === '/inhome/popularPlans?lq2=y') {
        popularPlanPage = true;
    } else {
        topClassName =isStickyProgressBar && progressbar ? `w_Subheader w_Subheadertop` :'w_Subheader';        
    }

    let isStreamlinePage = false;
    if (pathName === '/inhome/streamlineordering' || pathName ==='/inhome/streamlinetvvoice' || lqState?.streamlineLQ)
        isStreamlinePage = true;

    const [scrolltopdataClassName, setscrolltopdataClassName] = useState(topClassName);

    useEffect(() => {
        const scrollTotal = document.body.scrollTop || document.documentElement.scrollTop; 
        if(isCartDataEmpty && cartState?.isCartOpen){
          setscrolltopdataClassName('w_SubheaderSticky position-absolute')
          
        }
        else if(isCartDataEmpty && !cartState?.isCartOpen){
          if((pathName === '/inhome/popularPlans' || pathName=== '/inhome/ordersummary' ||  pathName === '/inhome/checkout' ||  pathName === '/inhome/popularPlans?lq2=y')){
              setscrolltopdataClassName(topClassName) 
          }
          else if(pathName.includes('/inhome/buildproducts')){
              if(cartState?.cartData?.length===0 || cartState?.cartData?.[splitBillTab]?.serviceHeaders === null || (cartState?.cartData?.[splitBillTab]?.serviceHeaders === 'undefined') ){
                  setscrolltopdataClassName(isStickyProgressBar || scrollTotal >= 5 ?'w_SubheaderSticky':'w_Subheader hide');
              }
              else{
                  setscrolltopdataClassName(isStickyProgressBar && scrollTotal < 5 ? 'w_Subheader w_Subheadertop' :'w_SubheaderSticky');
              }
              
          }
        }
        
        if(cartState?.cartData?.length===0 || cartState?.cartData?.[splitBillTab]?.serviceHeaders === null){
          if(isStickyProgressBar)
              setscrolltopdataClassName(isStickyProgressBar && buildProductPage ? 'w_Subheader w_Subheadertop' : 'w_Subheader');            
          else
            setscrolltopdataClassName('w_Subheader hide');
  
        }
  
        if(cartState?.isCartOpen){
          document.getElementById("fiosHeaderLq").style.position = "relative"; 
        }
        else if(!cartState.isCartOpen){
          document.getElementById("fiosHeaderLq").style.position = "relative"; 
        }
       
      }, [cartState?.isCartOpen, pathName, cartState]);

      useEffect(() =>{
        
        const handleScroll = () => {
            const scrollTotal = document.body.scrollTop || document.documentElement.scrollTop; 
                    
            if(!cartState?.isCartOpen){
                if(cartState?.cartData?.length!==0 && cartState?.cartData?.[splitBillTab]?.serviceHeaders !== null && (cartState?.cartData?.[splitBillTab]?.serviceHeaders !== 'undefined') || isStickyProgressBar){
                    if (scrollTotal > 5) { 
                        setscrolltopdataClassName('w_SubheaderSticky');                       
                    }
                    else if(scrollTotal <= 2){
                        setscrolltopdataClassName(topClassName)                        
                    }

                }
                else{
                    setscrolltopdataClassName(isStickyProgressBar? 'w_SubheaderSticky' :'hide');                    
                }
                
            }
            else if(cartState?.cartData?.length===0 || cartState?.cartData?.[splitBillTab]?.serviceHeaders === null || (cartState?.cartData?.[splitBillTab]?.serviceHeaders === 'undefined')){                
                setscrolltopdataClassName(isStickyProgressBar? 'w_Subheader w_Subheadertop' :'hide');                
            }
       
          };
      
          window.addEventListener('scroll', handleScroll, true);
      
          return () => {
            window.removeEventListener('scroll', handleScroll, true);
          };
    })

    const lineSection = (!isMobile || isStickyProgressBar) && !cartState.isCartOpen ? <div className={ popularPlanPage && !isMobile ? 'popularPlanPageLine' : '' } style={{paddingTop:'1rem',paddingLeft: isMobile ? '0rem' : (buildProductPage ? '0.2rem' : checkoutpage ? '':'1rem') }}>
    <Line type="secondary" />
    </div> : '';

    useEffect(() => {        
        window.addEventListener("resize", handleResize, false);
    },[]);

    const handleResize = () => {
        setIsMobile((window.screen.width < 744));
        setIsTablet(!!((window.screen.width > 743 && window.screen.width < 1025)))
    }


    return (<>
        <div id="fiosSubHeader" className={`${scrolltopdataClassName} bg-white ${(isMobile && !isStickyProgressBar) ? 'hide' : ''} ${isStreamlinePage ? "isStreamlinePageGudNewsBaner" : ""}` } style={{paddingTop: isTablet ? '0px' : '', opacity: ((isMobile || isTablet) && cartState?.isCartOpen) ?  0.7: ''}}>
            {(!isStreamlinePage || (isStreamlinePage && (pathName=== '/inhome/checkout'))) && 
            <>
            {(isMobile && isStickyProgressBar) ? <><ProgressBar isMobile={isMobile} isTablet={isTablet} lineSection={lineSection}/>  </>
               : <> 
               <div className="padding-top-zero m_ordering-page main padding-bottom-zero ">
                   <div className={`accordion_wrapper tiny-margin-top-zero  OvrallMrgnRskn ${checkoutpage ? 'w_checkout w_checkout_reskin':''}`} style={{display:'block', marginBottom: (pathName=== '/inhome/checkout') ? '0px' : ''}}>
                       <div className={ popularPlanPage && !isMobile ? 'popularPlanPageLine ' : '' } style={{display:'flex', flexDirection: !isStickyProgressBar ?'row-reverse' : 'row', justifyContent:'space-between', paddingLeft: isMobile ? '0rem' : (buildProductPage ? '0.2rem' : checkoutpage ? '':'1rem'),paddingTop:'8px',paddingBottom:'8px', width: '100%'}} >
                           {isStickyProgressBar && <ProgressBar isMobile={isMobile} isTablet={isTablet} mainclass={scrolltopdataClassName}/>}
                           {!cartEmptyCheck && (buildProductState?.stickyheaderfooter || buildProductState?.movesstickyheaderfooter ) &&  !isMobile ? <SaveMiniCart isMobile={isMobile} isTablet={isTablet} nsiPage={nsiPage} popularPlanPage={popularPlanPage} onOpenModal={onOpenModal} onhandleKeyDownKeyDown={onhandleKeyDownKeyDown} isEnableSave={isEnableSave} btnData={btnData} progressbar={progressbar}  /> : ''}
                       </div>
                       {lineSection}                          
                   </div>               
               </div>          
               </>}</>}
            
        </div>    
    </>)
}

const mapStateToProps = (state) => ({
      lqState: state.loopQual,
      appState: state.app, 
      cartState: state.cart,  
      buildProductState: state.buildProduct,
    })
  
export default React.memo(connect(mapStateToProps)(MainSubHeader));